import { useParams } from 'react-router-dom';
import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { PurchaseCreateEditProvider } from './context/purchase-create-edit-context';
import { PurchaseCreateEditComponent } from './purchase-create-edit-component';

export function PurchaseCreateEditFactory() {
    // A chave reinicia o estado quando a rota passa de inclusão para edição após salvar
    const { purchaseId } = useParams();

    return (
        <BaseLayoutFactory>
            <PurchaseCreateEditProvider key={purchaseId ?? 'new'}>
                <PurchaseCreateEditComponent />
            </PurchaseCreateEditProvider>
        </BaseLayoutFactory>
    );
}
